import http from './http';
import sorter from "./sorter";
import { UPDATE_ATTENDEES_ENDPOINT } from './endpoints';

export default (() => {

    const updateMultiple = (attendees) => {

        return http.put(UPDATE_ATTENDEES_ENDPOINT, attendees);
    };

    return {
        updateMultiple
    };

})();

export function sortAttendees(attendees, attribute, direction) {

    if (direction === 'asc') {

        return attendees.sort(sorter.sortAscending.bind(null, attribute));

    } else if (direction === 'desc') {

        return attendees.sort(sorter.sortDescending.bind(null, attribute));

    } else {

        return attendees.sort(sorter.sortAscending.bind(null, 'created_at'));
    }
}

export function getUpdatedAttendeeSorts(events, eventId, attribute, direction) {

    return events.reduce((map, event) => {

        map[event.id] = {
            organisation: null,
            last_name: null
        };

        if (eventId === event.id) {

            map[event.id][attribute] = direction;
        }

        return map;

    }, {});
}

export function toggleSelectAllAttendees(courses, courseId) {

    return courses.map((course) => {

        if (course.id === courseId) {

            return {
                ...course,
                isSelectingAllAttendees: !course.isSelectingAllAttendees,
                attendees: course.attendees.map((attendee) => {

                    return {
                        ...attendee,
                        selected: !course.isSelectingAllAttendees
                    };
                })
            };

        } else {

            return course;
        }
    })
}

export function setSelectedAttendee(courses, courseId, attendeeId, isSelected) {

    return courses.map((course) => {

        if (course.id === courseId) {

            return {
                ...course,
                attendees: course.attendees.map((attendee) => {

                    if (attendee.id === attendeeId) {

                        return {
                            ...attendee,
                            selected: isSelected
                        }

                    } else {

                        return attendee;
                    }
                })
            };

        } else {

            return course;
        }
    })
}

export function resetSelectAllAttendees(courses, courseIdToEdit) {

    return courses.map((course) => {

        if (course.id === courseIdToEdit) {

            return {
                ...course,
                isSelectingAllAttendees: false
            };

        } else {

            return course;
        }
    })
}


// WEBPACK FOOTER //
// ./services/attendees.js